
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Consolas from '../../fonts/Consolas';
import { H4 } from '../../helper/constants';
import { MenuItemProps } from './helper';
import React from "react"
const MenuItem = ({onClick, title, icon}: MenuItemProps): JSX.Element => 
(
    <ListItem disablePadding onClick={onClick}>
        <ListItemButton >
            <ListItemIcon>{icon}</ListItemIcon>
            <Consolas as={H4}>{title}</Consolas>
        </ListItemButton>
    </ListItem>
)

export default MenuItem;
